const {
  COUNTRIES_MAP,
} = require('../constants/countries');


module.exports = (key) => {
  const line = COUNTRIES_MAP[key];
  return line ? line[0] : key || '-';
};
